import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_portalvue_2f63a5cd from 'nuxt_plugin_portalvue_2f63a5cd' // Source: ./portal-vue.js (mode: 'all')
import nuxt_plugin_workbox_6cf6843c from 'nuxt_plugin_workbox_6cf6843c' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_313b02f5 from 'nuxt_plugin_metaplugin_313b02f5' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_35e2a869 from 'nuxt_plugin_iconplugin_35e2a869' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_axios_80c87b74 from 'nuxt_plugin_axios_80c87b74' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_plugin_12b1814d from 'nuxt_plugin_plugin_12b1814d' // Source: ./umbraco-client/plugin.js (mode: 'all')
import nuxt_plugin_lazysizesclient_16bbb752 from 'nuxt_plugin_lazysizesclient_16bbb752' // Source: ./lazysizes.client.js (mode: 'client')
import nuxt_plugin_vuexroutersync_9c8d1186 from 'nuxt_plugin_vuexroutersync_9c8d1186' // Source: ../plugins/vuex-router-sync.js (mode: 'all')
import nuxt_plugin_focusvisibleclient_2a620c36 from 'nuxt_plugin_focusvisibleclient_2a620c36' // Source: ../plugins/focus-visible.client.js (mode: 'client')
import nuxt_plugin_globalcomponents_cef56976 from 'nuxt_plugin_globalcomponents_cef56976' // Source: ../citi-baseline/plugins/global-components.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"script":[{"type":"application\u002Fld+json","json":{"@context":"https:\u002F\u002Fschema.org","@graph":[{"@type":"GovernmentOrganization","@id":"https:\u002F\u002Fflyttilvestfyn.assens.dk\u002F#organization","name":"Assens Kommune","url":"https:\u002F\u002Fwww.assens.dk\u002F","logo":{"@type":"ImageObject","url":"https:\u002F\u002Fcdn.moliri.dk\u002Fimage\u002Fmoliri-public\u002Fassenskommune\u002Fthumbnail?filename=Assens-Kommune---Logo.gif&folderPath=Assens_dk%2fStabene%2fOrganisation+og+Strategi%2fGrafik&width=600"},"sameAs":["https:\u002F\u002Fwww.facebook.com\u002Fassenskommune\u002F","https:\u002F\u002Fwww.linkedin.com\u002Fcompany\u002Fassens-kommune-lokal-government-administration\u002F","https:\u002F\u002Fwww.youtube.com\u002Fuser\u002FAssenskommune","https:\u002F\u002Fda.wikipedia.org\u002Fwiki\u002FAssens_Kommune","https:\u002F\u002Fvideo.assens.dk\u002F","https:\u002F\u002Fvia.ritzau.dk\u002Fnyhedsrum\u002F13561442\u002Fassens-kommune"]},{"@type":"AdministrativeArea","@id":"https:\u002F\u002Fflyttilvestfyn.assens.dk\u002F#municipality","name":"Assens Kommune","containedInPlace":{"@type":"AdministrativeArea","name":"Syddanmark"}},{"@type":"WebSite","@id":"https:\u002F\u002Fflyttilvestfyn.assens.dk\u002F#website","name":"Flyt til Vestfyn","url":"https:\u002F\u002Fflyttilvestfyn.assens.dk\u002F","publisher":{"@id":"https:\u002F\u002Fflyttilvestfyn.assens.dk\u002F#organization"},"about":{"@id":"https:\u002F\u002Fflyttilvestfyn.assens.dk\u002F#municipality"},"sameAs":["https:\u002F\u002Fwww.instagram.com\u002Fflyttilvestfyn\u002F"]},{"@type":"Place","@id":"https:\u002F\u002Fflyttilvestfyn.assens.dk\u002F#place","name":"Assens","address":{"@type":"PostalAddress","addressLocality":"Assens","addressRegion":"Syddanmark","postalCode":"5610","addressCountry":"DK"},"geo":{"@type":"GeoCoordinates","latitude":"55.3013","longitude":"10.0327"}}]}},{"hid":"lazysizes-config","innerHTML":"try {window.lazySizesConfig = JSON.parse('{\"init\":false,\"loadingClass\":\"is-lazyloading\",\"loadedClass\":\"is-lazyloaded\"}');} catch (error) {console.error('Failed to parse `window.lazySizesConfig`: ', error);window.lazySizesConfig = { init: false };}","once":true,"pbody":true},{"hid":"gf-script","innerHTML":"(function(){var l=document.createElement('link');l.rel=\"stylesheet\";l.href=\"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Rubik:wght@400;600;700&family=Caveat+Brush:wght@400\";document.querySelector(\"head\").appendChild(l);})();"}],"meta":[],"link":[{"hid":"gf-prefetch","rel":"dns-prefetch","href":"https:\u002F\u002Ffonts.gstatic.com\u002F"},{"hid":"gf-preconnect","rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com\u002F","crossorigin":""},{"hid":"gf-preload","rel":"preload","as":"style","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Rubik:wght@400;600;700&family=Caveat+Brush:wght@400"}],"style":[],"__dangerouslyDisableSanitizersByTagID":{"lazysizes-config":["innerHTML"],"gf-script":["innerHTML"],"gf-noscript":["innerHTML"]},"noscript":[{"hid":"gf-noscript","innerHTML":"\u003Clink rel=\"stylesheet\" href=\"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Rubik:wght@400;600;700&family=Caveat+Brush:wght@400\"\u003E"}]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_portalvue_2f63a5cd === 'function') {
    await nuxt_plugin_portalvue_2f63a5cd(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_6cf6843c === 'function') {
    await nuxt_plugin_workbox_6cf6843c(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_313b02f5 === 'function') {
    await nuxt_plugin_metaplugin_313b02f5(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_35e2a869 === 'function') {
    await nuxt_plugin_iconplugin_35e2a869(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_80c87b74 === 'function') {
    await nuxt_plugin_axios_80c87b74(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_12b1814d === 'function') {
    await nuxt_plugin_plugin_12b1814d(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_lazysizesclient_16bbb752 === 'function') {
    await nuxt_plugin_lazysizesclient_16bbb752(app.context, inject)
  }

  if (typeof nuxt_plugin_vuexroutersync_9c8d1186 === 'function') {
    await nuxt_plugin_vuexroutersync_9c8d1186(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_focusvisibleclient_2a620c36 === 'function') {
    await nuxt_plugin_focusvisibleclient_2a620c36(app.context, inject)
  }

  if (typeof nuxt_plugin_globalcomponents_cef56976 === 'function') {
    await nuxt_plugin_globalcomponents_cef56976(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
